import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
const prepareVideosToServer = (body: IPropertyForm) => {
  if (body.videos_property) {
    return body.videos_property.filter(
      x => typeof x !== "undefined" && x !== null && x !== ""
    );
  }
  return [];
};

export default prepareVideosToServer;
